module.exports = __webpack_public_path__ + "static/media/ITN_logo.2f311a05.svg";